module.exports = __webpack_public_path__ + "img/title1.01f1d1e9.png";